import { Component } from '@opten/compiler/metadata/component';

@Component({ className: 'js-form' })
export class FormComponent {

	private fields: HTMLInputElement[];

	constructor(private form: HTMLFormElement) {
		this.fields = Array.from(this.form.querySelectorAll('[required]'));

		this.form.setAttribute('novalidate', 'novalidate');

		this.fields.forEach(field => field.addEventListener('blur', () => this.validate(field)));
		this.form.addEventListener('submit', (ev) => this.submit(ev));
	}

	private validate(input: HTMLInputElement): boolean {
		const validity = input.validity;

		

		return validity.valid;
	}

	private submit(event: Event): void {
		const validations = this.fields.map(field => this.validate(field));
		if (validations.some(v => v === false)) {
			event.preventDefault();
		}
	}
}